import BaseNormalizer from "./BaseNormalizer";

const productFeedbackTodosNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "createdAt",
  "deletedAt",
  "dueDate",
  "product.id",
  "product.name",
  "product.vat",
  "product.rrp",
  "product.productGroup",
  "product.purchasingPrice",
  "product.salesUnitType",
  "product.salesUnitQuantity",
  "product.ean",
  "product.supplierArticleNumber",
  "product.valueProposition",
  "product.packaging",
  "product.usp",
  "product.brand",
  "product.flyerOrderable",
  "product.sampleOrderContent",
  "product.specialEventsInMarket",
  "product.publishOn",
  "product.favoritesCount",
  "product.alert",
  "product.newProductCategory",
  "product.images",
  "product.isFavorite",
  "product.favoriteCount",
  "product.absoluteSellingMerchantStoreCount",
  "product.averageSalesCountPerStorePerWeek",
  "product.genericProductName",
  "product.productVariantName",
]);

export default productFeedbackTodosNormalizer;
